﻿<script>
	import { fade } from "svelte/transition";
</script>

<section in:fade|local={{ duration: 500 }} out:fade|local={{ duration: 0 }}>
	<slot></slot>
</section>
